export function acessoPermitido(props, acesso) {
	if (
		props &&
		props.role &&
		Object.getOwnPropertyNames(props.role).length > 0
	) {
		const acessoStr = acesso.charAt(0).toLowerCase() + acesso.slice(1);
		if (!props.role[acessoStr] && props.role[acessoStr] !== false) {
			//console.error(acesso, props.role[acesso]);
			return true;
		}
		return props.role[acessoStr];
	} else {
		return false;

	}
}



// WEBPACK FOOTER //
// ./src/acessos.seguranca.js